module.exports = __webpack_public_path__ + "static/media/detail_0045_t.0ccb4460.jpg";